import { Badge } from '@cimplico/components';
import { ClientQueryStatusEnum } from '../../types/client-query';

type ClientQueryStatusProps = {
    status: ClientQueryStatusEnum;
};

function ClientQueryStatus({ status }: ClientQueryStatusProps): JSX.Element {
    if (status === ClientQueryStatusEnum.ACTIVE) {
        return <Badge color="yellow" size="small" label="Active" shape="squared" />;
    } else if (status === ClientQueryStatusEnum.DRAFT) {
        return <Badge color="red" size="small" label="Draft" shape="squared" />;
    }
    return <Badge color="green" size="small" label="Resolved" shape="squared" />;
}
export default ClientQueryStatus;
